import React from 'react';
import classNames from 'classnames';


function Section({ children, fillVertically, ...remainingProps }) {
  return (
    <section
      className={classNames(
        'section',
        { 'section--filled': fillVertically })
      }
      {...remainingProps}
    >
      <div className="section__overlay" />
      <div className="section__content">
        {children}
      </div>
    </section>
  );
}


export default Section;
